import React from 'react';

import cs from 'classnames';
import moment from 'moment-tz';

import {useCurrentUserState} from 'app/current-user/api';
import {SweetDatePicker} from 'app/general/widgets/SweetDatePicker';
import {localiseDate} from 'app/tasks/utils';
import {gt} from 'app/utils/i18n';

interface Props {
  due: string | null;
  onChange: (due: string) => unknown;
  lockDueDate: boolean;
}

export function DueDateInputField({
  due,
  onChange,
  lockDueDate,
}: Props): JSX.Element {
  const {timezone} = useCurrentUserState().data!;

  function restoreTime(date: Date): Date {
    let newDue = moment.tz(date, timezone);
    if (due != null) {
      let prevDue = localiseDate(due, timezone);
      newDue = newDue.hour(prevDue.hour()).minute(prevDue.minute());
    }

    return newDue.toDate();
  }

  function getDateWithoutTime() {
    const localizedMoment = localiseDate(due, timezone);
    return new Date(
      localizedMoment.year(),
      localizedMoment.month(),
      localizedMoment.date()
    );
  }

  return (
    <SweetDatePicker
      format="ll"
      className={cs('form-control', {
        disabled: lockDueDate,
      })}
      value={getDateWithoutTime()} // Returning just the ``Day`` part without the
      // ``time`` is crucial here for fixing the browser + timezone mismatch
      placeholder={gt('Due Date')}
      disabled={lockDueDate}
      onChange={(dates) => onChange(restoreTime(dates[0]).toISOString())}
    />
  );
}
